import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/common";
import { PostCard } from "../components/DiscussionBoard";

/* Saved community posts — reachable from My Travel Hub. */
export default function SavedCommunityPosts() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  const load = useCallback(() => api.get("/community/posts/saved")
    .then((r) => setItems(r.data.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);

  const react = async (id, kindR) => { try { await api.post(`/community/posts/${id}/react`, { kind: kindR }); load(); } catch { /* noop */ } };
  const save = async (id) => {
    try { await api.post(`/community/posts/${id}/save`); setItems((p) => p.filter((x) => x.id !== id)); toast.success("Removed from saved"); } catch { /* noop */ }
  };
  const report = async (id) => {
    const reason = window.prompt("Why are you reporting this post? (optional)") ?? null;
    if (reason === null) return;
    try { await api.post(`/community/posts/${id}/report`, { reason }); toast.success("Reported"); } catch { /* noop */ }
  };
  const del = async (id) => { try { await api.delete(`/community/posts/${id}`); setItems((p) => p.filter((x) => x.id !== id)); } catch { /* noop */ } };
  const solve = async (postId, commentId) => { try { await api.post(`/community/posts/${postId}/solve`, { comment_id: commentId }); load(); } catch { /* noop */ } };

  if (!items) return <Spinner full />;
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-8" data-testid="saved-posts-page">
      <h1 className="font-heading font-900 text-3xl flex items-center gap-2 mb-1"><Bookmark className="w-7 h-7 text-amber-500" /> Saved Community Posts</h1>
      <p className="text-sm text-muted-foreground mb-6">Tips, deals, answers and updates you bookmarked across all discussions.</p>
      {items.length === 0 ? (
        <div className="text-sm text-muted-foreground border border-dashed border-zinc-300 p-8 text-center space-y-3" data-testid="saved-posts-empty">
          <p>Nothing saved yet — tap the <Bookmark className="w-3.5 h-3.5 inline" /> bookmark on any community post to keep it here.</p>
          <Link to="/community" data-testid="saved-posts-community-link"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-700 text-white bg-fuchsia-600 hover:bg-fuchsia-700 transition-colors">
            Explore the Community
          </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((p) => (
            <PostCard key={p.id} p={p} user={user} canOfficial={false} followed={new Set()} onFollow={() => {}}
              onReact={react} onSave={save} onReport={report} onDelete={del} onReload={load} onSolve={solve} isStory={false} />
          ))}
        </div>
      )}
    </div>
  );
}
